import React from "react";
import { Container, Card, Button } from "react-bootstrap";
import { Check, X } from "react-bootstrap-icons";
import { Currency } from "../../../lib/components/Currency";
import { SubmitButton, CancelButton } from "../shared";
import { plural } from "./helpers";

// Render only when there's an active selection — the parent gates on selCount.
export function BulkActionBar({
  selCount,
  selAmount,
  blockedCount,
  approveCount,
  confirmDecline,
  isSaving,
  onRequestDecline,
  onCancelDecline,
  onConfirmDecline,
  onClear,
  onApprove,
}) {
  return (
    <div
      className="position-fixed bottom-0 start-0 end-0 d-flex justify-content-center commission-selection-bar"
      style={{ zIndex: 1030 }}
    >
      <Container className="px-3 pb-3 w-100" style={{ maxWidth: 768 }}>
        <Card className="bar-enter position-relative shadow-lg commission-selection-card">
          <span
            aria-hidden="true"
            className="bar-ring pe-none position-absolute top-0 start-0 end-0 bottom-0"
            style={{
              border: "2px solid var(--bs-success)",
              borderRadius: "inherit",
            }}
          />
          <Card.Body className="d-flex flex-wrap align-items-center gap-2 py-2 px-3">
            {confirmDecline ? (
              <>
                <p className="mb-0 text-body">
                  Decline {plural(selCount, "contract")}? You can reset any of
                  them individually afterward.
                </p>
                <div className="ms-auto d-flex align-items-center gap-2">
                  <CancelButton onClick={onCancelDecline} disabled={isSaving} />
                  <SubmitButton
                    text="Confirm decline"
                    color="red"
                    onClick={onConfirmDecline}
                    disabled={isSaving}
                    isSubmitting={isSaving}
                    icon={<X size={16} />}
                  />
                </div>
              </>
            ) : (
              <>
                <div className="min-w-0">
                  <p className="fw-medium mb-0">
                    {plural(selCount, "contract")} selected ·{" "}
                    <span className="tnum">
                      <Currency amount={selAmount} />
                    </span>
                  </p>
                  {blockedCount > 0 && (
                    <p className="small text-warning-emphasis mb-0 mt-1">
                      {plural(blockedCount, "contract")} cannot be approved due
                      to no agent or pending contract status
                    </p>
                  )}
                </div>
                <div className="ms-auto d-flex align-items-center gap-2">
                  <Button
                    variant="link"
                    size="sm"
                    onClick={onClear}
                    disabled={isSaving}
                    className="text-secondary text-decoration-none fw-medium"
                  >
                    Clear
                  </Button>
                  <SubmitButton
                    text={`Decline ${selCount}`}
                    color="red"
                    onClick={onRequestDecline}
                    disabled={isSaving}
                    isSubmitting={isSaving}
                    icon={<X size={16} />}
                  />
                  <SubmitButton
                    text={`Approve ${approveCount}`}
                    color="green"
                    onClick={onApprove}
                    disabled={approveCount === 0 || isSaving}
                    isSubmitting={isSaving}
                    title={
                      approveCount === 0
                        ? "Selected contracts cannot be approved due to no agent or pending contract status"
                        : undefined
                    }
                    icon={<Check size={16} />}
                  />
                </div>
              </>
            )}
          </Card.Body>
        </Card>
      </Container>
    </div>
  );
}
